import { VOLUNTEERING, AFFILIATIONS } from "../../data/content";

export const Volunteering = () => (
  <section className="section section--alt" id="volunteering" aria-labelledby="vol-heading">
    <div className="container">
      <div className="section-header">
        <div className="section-label">Community</div>
        <h2 className="section-heading" id="vol-heading">Volunteering &amp; <em>Community Leadership</em></h2>
        <p className="section-sub">
          Pro-bono evaluation, mentorship, and impact leadership — translating two decades of MERLA
          practice into service for charities, youth networks, and peacebuilding communities worldwide.
        </p>
      </div>

      <div className="vol-grid">
        {VOLUNTEERING.map((v, i) => {
          const Icon = v.icon;
          return (
            <article className="vol-card" key={v.org} data-testid={`volunteer-card-${i}`}>
              <div className="vol-icon" aria-hidden="true"><Icon size={22} strokeWidth={1.6} /></div>
              <div className="vol-body">
                <div className="vol-period">{v.period}</div>
                <h3 className="vol-role">{v.role}</h3>
                <div className="vol-org">{v.org}</div>
                <p className="vol-desc">{v.desc}</p>
              </div>
            </article>
          );
        })}
      </div>

      <div className="vol-affiliations" data-testid="affiliations">
        <div className="vol-aff-head">Professional Memberships &amp; Affiliations</div>
        <div className="vol-aff-chips">
          {AFFILIATIONS.map((a) => (
            <span className="vol-aff-chip" key={a}>{a}</span>
          ))}
        </div>
      </div>
    </div>
  </section>
);
